import React from 'react';
import { getUserId, useAuthState } from '../../../components/AuthContextProvider';
import { DataIndicators } from '../../../components/DataIndicators';
import { DataProviderCache } from '../../../data/DataProviders/DataProviderCache';
import { useOrganizationData } from '../../../data/DataProviders/OrganizationDataProvider';
import { RegistrationRoleProvider } from '../../../data/DataProviders/RegistrationRoleProvider';
import { UserInfoProvider } from '../../../data/DataProviders/UserInfoProvider';
import { UserRoleLocationProvider } from '../../../data/DataProviders/UserRoleLocationProvider';
import { useCurrentAppRoute } from '../../../hooks/app-route-hooks';
import { isRecordFound, useUserRoles } from '../../../hooks/data-hooks';
import { isDataLoaded, UserRole } from '../../../types';
import { EditUser } from './EditUser';

export const EditUserInfo: React.FC = () => {
    const orgLocationData = useOrganizationData();
    const currentAppRoute = useCurrentAppRoute();
    const userId = getUserId(useAuthState());
    const userRole = useUserRoles();
    const [siteId, setSiteId] = React.useState('');
    const [orgId, setOrgId] = React.useState('');
    const isEmpty = isDataLoaded(orgLocationData);
    
    React.useEffect(() => {
        if (isRecordFound(userRole) && isDataLoaded(orgLocationData)) {
            setOrgId(orgLocationData.value.id);
            setSiteId(orgLocationData.value.id);
            const isLocationAdmin = userRole.value.filter((x) => x.roleName === UserRole.LocationAdmin);
            if (isLocationAdmin.length > 0) {
                setSiteId(isLocationAdmin[0].siteId);
            }
        }
    }, [userRole, orgLocationData]);
    return (
        <>
            {!isDataLoaded(orgLocationData) && (
                <DataIndicators
                    errorMessage="No Data"
                    emptyMessage="No Data"
                    data={orgLocationData}
                    emptyIcon="Person"
                    isEmpty={isEmpty}
                />
            )}
            {'userId' in currentAppRoute && isDataLoaded(orgLocationData) && (
                <DataProviderCache for={'User Info'}>
                    <UserInfoProvider userId={currentAppRoute.userId}>
                        {orgId && userId && (
                            <DataProviderCache for={'RegistrationRole'}>
                                <RegistrationRoleProvider userId={userId} siteId={siteId}>
                                    <UserRoleLocationProvider userId={currentAppRoute.userId} organizationId={orgLocationData.value.id}>
                                        <EditUser userId={currentAppRoute.userId} />
                                    </UserRoleLocationProvider>
                                </RegistrationRoleProvider>
                            </DataProviderCache>
                        )}
                    </UserInfoProvider>
                </DataProviderCache>
            )}
        </>
    );
};
